import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export const unassignPayPalStoreAccount = (storeId: number): AxiosPromise<{ success: boolean }> => {
  return httpClient({
    method: 'DELETE',
    url: `/super-admin/stores/${storeId}/paypal-account`,
  });
};
